import { legacyApiResourceUrl } from "@ploy-lib/core";
import { BaseCamelCasedResource } from "../resources/BaseResource";
export class ProofOfDeliveryReleasedInformationResource extends BaseCamelCasedResource {
    pk() {
        return this.applicationNumber;
    }
}
ProofOfDeliveryReleasedInformationResource.urlRoot = legacyApiResourceUrl("ProofOfDelivery/IsProofOfDeliveryReleased");
//# sourceMappingURL=ProofOfDeliveryReleasedResource.js.map